<script setup>
// https://vue3-infinite-loading.netlify.app/
import InfiniteLoading from 'v3-infinite-loading'
// required if you're not going to override default slots
import 'v3-infinite-loading/lib/style.css'
</script>

<template>
  <div class="w-full flex justify-center">
    <ClientOnly>
      <InfiniteLoading v-bind="$attrs"> </InfiniteLoading>
    </ClientOnly>
  </div>
</template>
